import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SidebarService } from './../sidebar/sidebar.service'
import { CommonService } from '../services/common.service';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})

export class SidebarComponent implements OnInit {
    is_admin: boolean = false;

    role: String;
  
    constructor(public sidebarservice: SidebarService, private common: CommonService) { }

    getSideBarSate() {
        return this.sidebarservice.getSidebarState();
    }
  
    ngOnInit() {
        let userData = localStorage.getItem('user');
        const user = typeof userData === 'string' ? JSON.parse(userData) : userData;
        this.role = user?.role;
        console.log(this.role);
        this.for_admin()
    }
    for_admin(){
        const userData = localStorage.getItem('user')
        const user = JSON.parse(userData)
        if(user.role == 'admin'){
          this.is_admin = true
        }
      }
    

}
